import { createFileRoute } from '@tanstack/react-router'
import { AuthLayout, SignUpForm } from '../ui'

export const Route = createFileRoute('/signup/$')({
	component: RouteComponent,
})

function RouteComponent() {
	return (
		<AuthLayout>
			<SignUpForm />
		</AuthLayout>
	)
}
